module.exports = __webpack_public_path__ + "img/user-secret.09cd6eca.svg";